import { render, staticRenderFns } from "./JzzDashTapinGoal.vue?vue&type=template&id=1ecfccd2&scoped=true"
import script from "./JzzDashTapinGoal.vue?vue&type=script&lang=js"
export * from "./JzzDashTapinGoal.vue?vue&type=script&lang=js"
import style0 from "./JzzDashTapinGoal.vue?vue&type=style&index=0&id=1ecfccd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecfccd2",
  null
  
)

export default component.exports